export const ProjectData = [
  {
    key: 6,
    className: "project7",
    title: "Definitely Not Wordle",
    description:
      "Definitely Not Wordle is a mock of famous web app game called Wordle. Built to reverse engineer the game to learn React, Redux and TypeScript. In addition, an Express API was also built to grab the word of the day. Cypress Testing was also added to get familiar with front-end testing and automation.",
    tech: "React, TypeScript, Redux, Cypress",
    deployed: [
      "https://wordle-react-app.vercel.app/",
      "https://wordle-api-geearen.onrender.com/home",
    ],
    github: [
      "https://github.com/geearen/wordle-react-app",
      "https://github.com/geearen/wordle-api",
    ],
  },
  {
    key: 5,
    className: "project6",
    title: "Anime Therapy",
    description:
      "AnimeSelfCare.org is your place for calm, focus and productivity using anime. Enjoy some relaxing anime tunes, download your favorite Anime Self Care Kit and create your perfect sound environment.",
    tech: "React and Tailwind",
    deployed: ["https://demo.animetherapy.org/"],
    github: ["https://github.com/geearen/"],
  },
  {
    key: 4,
    className: "project5",
    title: "Outlet",
    description:
      "Outlet is a responsive drawing app where you can create art of your own. Draw with pen and fun shapes, save to your computer, clear, and draw again!",
    tech: "React and SASS",
    deployed: ["https://outlet.vercel.app//"],
    github: ["https://github.com/geearen/Outlet"],
  },
  {
    key: 3,
    className: "project4",
    title: "FotoNegative",
    description:
      "FotoNegative is a full stack application targeting on photographers and hobbyists, where it allows users to views different types of camera from film to digital. Inspired by KenRockwell.com and Instagram",
    tech: "Node.js, Express.js, MongoDB, SASS, UIkit, AWS S3 and Unsplash API",
    deployed: ["https://foto-negative.vercel.app/home"],
    github: ["https://github.com/geearen/FotoNegative"],
  },
  {
    key: 2,
    className: "project3",
    title: "The Wayfarer",
    description:
      "Wayfarer is a travel app aimed specifically at enabling users to post nightlife stories and tips for the cities of their choice.",
    tech: "Python, Django, PostgreSQL, CSS, jQuery and Skeleton",
    deployed: ["https://the-number-one-wayfarer.herokuapp.com/"],
    github: ["https://github.com/geearen/the-wayfarer"],
  },
  {
    key: 1,
    className: "project2",
    title: "Goodeats",
    description:
      "Goodeats is a recipe website where user get to share their recipes.",
    tech: "Node.js, Express.js, MongoDB, SASS, Semantic UI and jQuery",
    deployed: ["https://goodeats-umber.vercel.app/"],
    github: ["https://github.com/geearen/Goodeats"],
  },
  {
    key: 0,
    className: "project1",
    title: "Jujutsu Kaisen-Gotchi",
    description:
      "Jujutsu Kaisen-Gotchi was my first project I built as a part of General Assembly's Software Engineering Immersive Program.",
    tech: "HTML, CSS, JavaScript, Animate.CSS, and NES CSS Framework",
    deployed: ["https://geearen.github.io/Jujutsu-Kaisen-Gotchi/"],
    github: ["https://github.com/geearen/Jujutsu-Kaisen-Gotchi"],
  },
];
